import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Goals = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="topdf-goals" bigPaddings={true} isMargin={false}>
                <CommonTitle className="topdf-goals__title">Цели</CommonTitle>
                <div className="topdf-goals__container">
                    <ScrollAnimation
                        delay={100}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="topdf-goals__item"
                    >
                        <div className="topdf-goals__img">
                            <img
                                src="/images/svg/topdf/topdf-goals__img1.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <CommonSmallText className="topdf-goals__text">
                            Наша главная цель&nbsp;&mdash; сделать лучшую мировую платформу для
                            работы с&nbsp;PDF-файлами.
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        delay={200}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="topdf-goals__item"
                    >
                        <div className="topdf-goals__img">
                            <img
                                src="/images/svg/topdf/topdf-goals__img2.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <CommonSmallText className="topdf-goals__text">
                            Запустить 21&nbsp;микросервис для работы с&nbsp;PDF-файлами
                            с&nbsp;ежемесячным охватом минимум
                            в&nbsp;10&nbsp;000&nbsp;000&nbsp;человек.
                        </CommonSmallText>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Goals;
